import type { TFunction } from "i18next";

type PlanLike = {
  key: string;
  name: string;
  description: string;
};

type FeatureLike = {
  key: string;
  name: string;
};

function firstTranslation(t: TFunction, keys: string[]): string {
  for (const key of keys) {
    const translated = t(key);
    if (translated !== key) {
      return translated;
    }
  }

  return keys[keys.length - 1] ?? "";
}

export function translatePlanName(t: TFunction, plan: PlanLike): string {
  return firstTranslation(t, [
    `subscription-plan.${plan.name}`,
    `subscription-plan.${plan.key}`,
    plan.name,
  ]);
}

export function translatePlanDescription(t: TFunction, plan: PlanLike): string {
  return firstTranslation(t, [
    `subscription-plan.${plan.key}.description`,
    `subscription-plan.description.${plan.name}`,
    plan.description,
  ]);
}

export function translatePlanFeature(t: TFunction, feature: FeatureLike): string {
  return firstTranslation(t, [
    `subscription-feature.${feature.key}`,
    feature.name,
  ]);
}

export function translateIntervalUnit(t: TFunction, intervalUnit: string): string {
  return t(intervalUnit.toLowerCase());
}
